import { gql } from '@apollo/client';

export default gql`
  query OrderOfOperationsCount($reportID: UUID) {
    allRpOptSteps(filter: { reportId: { equalTo: $reportID } }) {
      totalCount
    }
  }
`;
